/**
 * Component Registry for Case Associates Corporate Theme
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { SmartHeader } from './components/SmartHeader';
import { SmartFooter } from './components/SmartFooter';
import { HomeHero } from './components/HomeHero';
import { PropertyHero } from './components/PropertyHero';
import { CTASection } from './components/CTASection';
import { CompanyWhatWeDo } from './components/CompanyWhatWeDo';
import { AboutSection } from './components/AboutSection';
import { CommunitiesSlider } from './components/CommunitiesSlider';
import { MissionSection } from './components/MissionSection';
import { StatsRow } from './components/StatsRow';
import { MapAndProperties } from './components/MapAndProperties';
import { CareersSection } from './components/CareersSection';
import { LocationLinks } from './components/LocationLinks';
import { PropertyListing } from './components/PropertyListing';
import { PropertyPromoBanner } from './components/PropertyPromoBanner';
import { PropertyAbout } from './components/PropertyAbout';
import { PropertyFloorPlansPreview } from './components/PropertyFloorPlansPreview';
import { PropertyAmenitiesPreview } from './components/PropertyAmenitiesPreview';
import { PropertyNeighborhoodPreview } from './components/PropertyNeighborhoodPreview';
import { PropertyFAQ } from './components/PropertyFAQ';
import { PropertyFooterCTA } from './components/PropertyFooterCTA';
import { AmenitiesList } from './components/AmenitiesList';
import { CityMarketPage } from './components/CityMarketPage';
import { StateListingPage } from './components/StateListingPage';
import { AboutPageHero } from './components/AboutPageHero';
import { AboutFeaturedText } from './components/AboutFeaturedText';
import { AboutImageSlider } from './components/AboutImageSlider';
import { PropertyFloorplansList } from './components/PropertyFloorplansList';
import { PropertyFloorplansFAQ } from './components/PropertyFloorplansFAQ';
import { PropertyNeighborhoodMap } from './components/PropertyNeighborhoodMap';
import { PropertyGallery } from './components/PropertyGallery';
import { PetPolicy } from './components/PetPolicy';
import { PropertySubpageHeader } from './components/PropertySubpageHeader';
import { ContactForm } from './components/ContactForm';
import { CorporateContactForm } from './components/CorporateContactForm';
import { OfficeHours } from './components/OfficeHours';
import { PropertyResourcesFooter } from './components/PropertyResourcesFooter';
import { PrivacyPageHero } from './components/PrivacyPageHero';
import { AccessibilityPageHero } from './components/AccessibilityPageHero';
import { PrivacyPolicyContent } from './components/PrivacyPolicyContent';
import { AccessibilityContent } from './components/AccessibilityContent';
import { ProgressReport } from './components/ProgressReport';
import { AwardsPageHero } from './components/AwardsPageHero';
import { AwardsIntro } from './components/AwardsIntro';
import { AwardsAccordion } from './components/AwardsAccordion';
import { CareersPageHero } from './components/CareersPageHero';
import { CareersIntro } from './components/CareersIntro';
import { CareersBenefits } from './components/CareersBenefits';
import { CareersEmployees } from './components/CareersEmployees';
import { TourSchedulerModal } from './components/TourSchedulerModal';
import { FlexPaymentBanner } from './components/FlexPaymentBanner';
import { SpecialOffers } from './components/SpecialOffers';
import { CorporateSpecialOffer } from './components/CorporateSpecialOffer';

export const registry: ComponentRegistry = {
  // Smart Header/Footer switch between corporate and property variants
  Header: SmartHeader,
  Footer: SmartFooter,
  Hero: HomeHero,
  PageHero: PropertyHero,

  // Corporate home page slots
  CTASection: CTASection,
  CorporateSpecialOffer: CorporateSpecialOffer,
  CompanyWhatWeDo: CompanyWhatWeDo,
  RichText: AboutSection,
  CommunitiesSlider: CommunitiesSlider,
  Gallery: null,
  CTAButton: MissionSection,
  Spacer: StatsRow,
  NeighborhoodMap: MapAndProperties,
  Reviews: CareersSection,
  SocialHub: LocationLinks,

  FloorplansList: PropertyListing,
  StateListing: StateListingPage,
  CityMarket: CityMarketPage,

  // About page slots
  AboutPageHero: AboutPageHero,
  AboutFeaturedText: AboutFeaturedText,
  AboutImageSlider: AboutImageSlider,

  // Property interior page slots (home page sections)
  PropertyPromoBanner: PropertyPromoBanner,
  PropertyAbout: PropertyAbout,
  PropertyFloorPlans: PropertyFloorPlansPreview,
  PropertyAmenities: PropertyAmenitiesPreview,
  PropertyNeighborhood: PropertyNeighborhoodPreview,
  PropertyFAQ: PropertyFAQ,
  PropertyFooterCTA: PropertyFooterCTA,

  // Property subpage shared header (breadcrumbs + title + blurb)
  PropertySubpageHeader: PropertySubpageHeader,

  // Property interior full pages
  AmenitiesList: AmenitiesList,
  PropertyFloorplansList: PropertyFloorplansList,
  PropertyFloorplansFAQ: PropertyFloorplansFAQ,
  PropertyNeighborhoodMap: PropertyNeighborhoodMap,
  PropertyGallery: PropertyGallery,
  PetPolicy: PetPolicy,
  ContactForm: ContactForm,
  CorporateContactForm: CorporateContactForm,
  OfficeHours: OfficeHours,
  PropertyResourcesFooter: PropertyResourcesFooter,

  PrivacyPageHero: PrivacyPageHero,
  AccessibilityPageHero: AccessibilityPageHero,
  PrivacyPolicyContent: PrivacyPolicyContent,
  AccessibilityContent: AccessibilityContent,

  ProgressReport: ProgressReport,

  // Awards page slots
  AwardsPageHero: AwardsPageHero,
  AwardsIntro: AwardsIntro,
  AwardsAccordion: AwardsAccordion,

  // Careers page slots
  CareersPageHero: CareersPageHero,
  CareersIntro: CareersIntro,
  CareersBenefits: CareersBenefits,
  CareersEmployees: CareersEmployees,

  // Tour scheduler modal (renders dialog overlay, no visible section)
  TourSchedulerModal: TourSchedulerModal,

  // Flex payment banner (renders mount point for Flex SDK widget)
  FlexPaymentBanner: FlexPaymentBanner,
  SpecialOffers: SpecialOffers,

  // Stubs for property-level slots not yet implemented
  Navigation: null,
  MobileDrawer: null,
  VirtualTourEmbed: null,
  Fees: null,
  Divider: null,
};

export default registry;
